import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';

import classNames from 'classnames';

import LeftSide from './left-side';
import PageHeader from './page-header';

import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import $ from 'jquery';
import * as alerts from "helpers/alerts";
import {find} from "helpers/functions";

import './page.less';
import FeedbackComponent from "components/modules/feedback/feedback";

@propTypes({
    pageId: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    headerActions: PropTypes.array,
    headerContents: PropTypes.array,
    showHeader: PropTypes.bool
})

@defaultProps({
    pageId: 'Main',
    className: '',
    headerActions: [],
    headerContents: [],
    showHeader: true
})

export default class PageComponent extends Component {

    state = {
        showFeedback: false,
    };

    render() {
        let menu = [];
        if (window.RNIS_SETTINGS.CUSTOMMENU === false || window.RNIS_SETTINGS.CUSTOMMENU === undefined || window.RNIS_SETTINGS.CUSTOMMENU === "undefined") {
            menu = [
                {
                    text: 'Новости',
                    class: 'news',
                    route: '/',
                },
                {
                    text: 'Пассажирские перевозки',
                    class: 'passenger',
                    key: 'passenger',
                    submenu: [
                        {
                            text: 'Забытые вещи',
                            class: 'forgotten-things',
                            route: '/page/forgotten',
                        },
                        {
                            text: 'Информация',
                            class: 'information',
                            route: '/page/info',
                        },
                        {
                            text: 'Перевозчики',
                            class: 'carrier',
                            route: '/carriers',
                        },
                        {
                            text: 'Расписания',
                            class: 'schedule',
                            route: '/schedule',
                        },
                    ]
                },
                {
                    text: 'Обслуживание дорог',
                    class: 'road',
                    route: '/map/road',
                },
                {
                    text: 'Вывоз мусора',
                    class: 'waste',
                    route: '/map/garbage',
                },
                {
                    text: 'Вопрос-ответ',
                    class: 'faq',
                    route: '/faq',
                },
                {
                    text: 'Подключение к РНИС МО',
                    class: 'connection',
                    key: 'connection',
                    submenu: [
                        {
                            text: 'Подключение к РНИС МО',
                            class: 'connection',
                            route: '/page/connection',
                        },
                        {
                            text: 'Нормативная и справочная информация',
                            class: 'nsi',
                            route: '/page/nsi',
                        },
                        {
                            text: 'Контакты',
                            class: 'phone',
                            route: '/page/contacts',
                        },
                    ],
                },
                /*{
                    text: 'Скоро',
                    class: 'soon',
                    key: 'soon',
                    submenu: [
                        {
                            text: 'Перевозки детей',
                            class: 'children',
                            route: '/soon/children',
                        },
                    ]
                },*/
                {
                    text: 'Обратная связь',
                    class: 'contact',
                    route: '/feedback',
                    onClick: ::this.onFeedbackClick,
                },
                {
                    text: 'Добродел',
                    class: 'dobrodel',
                    href: 'https://dobrodel.mosreg.ru/',
                },
            ];
            if (window.RNIS_SETTINGS.CITY_OMSK) {
                menu = menu.map(menuItem => {
                    if (menuItem.key === 'passenger') {
                        menuItem.submenu.splice(0, 0, {
                            text: 'Карта',
                            class: 'map',
                            route: '/map/bus',
                        });
                    }
                    return menuItem
                })
            } else {
                menu.splice(1, 0, {
                    text: 'Карта',
                    class: 'map',
                    route: '/map/bus',
                });
            }
        }

        if (window.RNIS_SETTINGS.CUSTOMMENU) {
            let a = window.RNIS_SETTINGS.CUSTOMMENUSTATE;
            menu = [
                find(a, ['text', 'Новости']).show ?
                {
                    text: 'Новости',
                    class: 'news',
                    route: '/',
                } : null,
                find(a, ['text', 'Карта']).show ?
                    {
                        text: 'Карта',
                        class: 'map',
                        route: '/map/bus',
                    } : null,
                find(a, ['text', 'Пассажирские перевозки']).show ?
                {
                    text: 'Пассажирские перевозки',
                    class: 'passenger',
                    key: 'passenger',
                    submenu: [
                        find(a, ['text', 'Пассажирские перевозки']).submenu[0].show ?
                            {
                                text: 'Карта',
                                class: 'map',
                                route: '/kiutr/map',
                            } : null,
                        find(a, ['text', 'Пассажирские перевозки']).submenu[1].show ?
                        {
                            text: 'Забытые вещи',
                            class: 'forgotten-things',
                            route: '/page/forgotten',
                        } : null,
                        find(a, ['text', 'Пассажирские перевозки']).submenu[2].show ?
                        {
                            text: 'Информация',
                            class: 'information',
                            route: '/page/info',
                        }: null,
                        find(a, ['text', 'Пассажирские перевозки']).submenu[3].show ?
                        {
                            text: 'Перевозчики',
                            class: 'carrier',
                            route: '/carriers',
                        }: null,
                        find(a, ['text', 'Пассажирские перевозки']).submenu[4].show ?
                        {
                            text: 'Расписания',
                            class: 'schedule',
                            route: '/schedule',
                        }: null,
                    ]
                } : null,

                find(a, ['text', 'Обслуживание дорог']).show ?
                {
                    text: 'Обслуживание дорог',
                    class: 'road',
                    route: '/map/road',
                } : null,

                find(a, ['text', 'Вывоз мусора']).show ?
                {
                    text: 'Вывоз мусора',
                    class: 'waste',
                    route: '/map/garbage',
                } : null,

                find(a, ['text', 'Коммунальная техника']).show ?
                {
                    text: 'Коммунальная техника',
                    class: 'communal',
                    route: '/map/communal',
                } : null,

                find(a, ['text', 'Вопрос-ответ']).show ?
                {
                    text: 'Вопрос-ответ',
                    class: 'faq',
                    route: '/faq',
                } : null,

                find(a, ['text', `Подключение к ${window.RNIS_SETTINGS.SHORT_TITLE}`]).show ?
                {
                    text: `Подключение к ${window.RNIS_SETTINGS.SHORT_TITLE}`,
                    class: 'connection',
                    key: 'connection',
                    submenu: [
                        find(a, ['text', `Подключение к ${window.RNIS_SETTINGS.SHORT_TITLE}`]).submenu[0].show ?
                        {
                            text: `Подключение к ${window.RNIS_SETTINGS.SHORT_TITLE}`,
                            class: 'connection',
                            route: '/page/connection',
                        } : null,
                        find(a, ['text', `Подключение к ${window.RNIS_SETTINGS.SHORT_TITLE}`]).submenu[1].show ?
                        {
                            text: 'Нормативная и справочная информация',
                            class: 'nsi',
                            route: '/page/nsi',
                        } : null,
                        find(a, ['text', `Подключение к ${window.RNIS_SETTINGS.SHORT_TITLE}`]).submenu[2].show ?
                        {
                            text: 'Контакты',
                            class: 'phone',
                            route: '/page/contacts',
                        } : null,
                    ],
                } : null,
                /*{
                    text: 'Скоро',
                    class: 'soon',
                    key: 'soon',
                    submenu: [
                        {
                            text: 'Перевозки детей',
                            class: 'children',
                            route: '/soon/children',
                        },
                    ]
                },*/
                find(a, ['text', 'Обратная связь']).show ?
                {
                    text: 'Обратная связь',
                    class: 'contact',
                    route: '/feedback',
                    onClick: ::this.onFeedbackClick,
                } : null,
                find(a, ['text', 'Добродел']).show ?
                {
                    text: 'Добродел',
                    class: 'dobrodel',
                    href: 'https://dobrodel.mosreg.ru/',
                } : null,
            ];
        }


        const header = this.props.showHeader ? (
            <PageHeader
                ref="header"
                title={this.props.title}
                actions={this.props.headerActions}
                contents={this.props.headerContents}/>
        ) : '';

        const className = classNames('page', this.props.showHeader ? 'with-page-header' : '');

        const feedback = this.state.showFeedback ? (
            <FeedbackComponent
                onClose={::this.feedbackClose}
            />
        ) : null;

        return (
            <div ref="container" className={className}>
                {header}
                <LeftSide menu={menu}/>

                {feedback}
                <div id={this.props.pageId} className={classNames('r-block', this.props.className)}>
                    {this.props.children}
                </div>
            </div>
        );
    }

    onFeedbackClick(e) {
        e && e.preventDefault();

        this.setState({
            showFeedback: true,
        });
        $(document).on('keyup', (e) => {
            if (e.keyCode === 27) {
                this.feedbackClose();
            }
        });
    }

    feedbackClose() {
        this.setState({
            showFeedback: false,
        });
        $(document).off('keyup');
    }

    onDemoClick(e) {
        e.preventDefault();

        alerts.alert('Находится в разработке');
    }

}



// WEBPACK FOOTER //
// ./src/components/ui/page.js